const urlRegexp = /https?:\/\//g;
export const isUrlExternal = (url: string): boolean => !!url?.match(urlRegexp);
